<ng-template #header>
  <h3>{{ 'action.download_profile' | translate }}</h3>
</ng-template>
<ng-template #content>
  <app-hoc-profile-download-form-component [email]="email" (closeDialog)="closeDialog($event)" />
</ng-template>
